export default __webpack_public_path__ + "static/media/trailer_1_2.ca66595e.svg";